import React from 'react';
import moment from 'moment';
import clsx from 'clsx';
import { Accordion } from '../components';
import { getDuration } from 'utils';
import styles from './EventList.module.scss';
import { ReactComponent as SidebarAlert } from 'assets/images/Sidebar--alert.svg';

const EventList = ({ selectedEvents, selectedDate }) => {
  return (
    <div>
      {selectedEvents.map((event, index) => {
        let start = moment(event.start).utcOffset(event.timezone);
        let startAlert = event.start_alert;
        let end = moment(event.end).utcOffset(event.timezone);
        let endAlert = event.end_alert;
        let startTime = start.format("hh:mm A");
        let endTime = end.format("hh:mm A");
        let startDate;
        let endDate;
        let duration = event.duration;

        if (!moment(end).isSame(start, 'day')) {
          startDate = start.format("dddd, MMMM Do");
          endDate = end.format("dddd, MMMM Do");
        }
        duration = duration ?? getDuration(end.diff(start, "hours"));

        return (
          <div key={index}>
            <Accordion
              title={event.title}
              color={event['event-color']}
              type='event'
              key={index + selectedDate}
              isOpened={selectedEvents.length === 1}
            >
              <div className={styles.accordion__content__inner}>
                {(start && !event.deadline) && (
                  <div className={styles.accordion__content__wrapper}>
                    <div className={styles.accordion__content__label}>Start: </div>
                    <div className={styles.accordion__content__text}>
                      {startTime && <span>{startTime} {event.zoneName}</span>}
                      {startDate && <span>{startDate}</span>}
                    </div>
                  </div>
                )}
                {startTime && startAlert === "true" && (
                  <div className={styles.accordion__content__wrapper}>
                    <div className={styles.accordion__content__label}><SidebarAlert /></div>
                    <div className={styles.accordion__content__text} style={{ color: '#750000', fontSize: "13px" }}>
                      <p>Start times vary; the event will most likely start sometime around {startTime}. You can check the server status <a rel="noreferrer" target='_blank' href={'https://www.seaofthieves.com/status'}>here</a>.</p>
                    </div>
                  </div>
                )}
                {(end && !event.announcement) && (
                  <div className={styles.accordion__content__wrapper}>
                    <div className={styles.accordion__content__label}>End: </div>
                    <div className={styles.accordion__content__text}>
                      {endTime && <span>{endTime} {event.zoneName}</span>}
                      {endDate && <span>{endDate}</span>}
                    </div>
                  </div>
                )}
                {endTime && endAlert === "true" && (
                  <div className={styles.accordion__content__wrapper}>
                    <div className={styles.accordion__content__label}><SidebarAlert /></div>
                    <div className={styles.accordion__content__text} style={{ color: '#750000', fontSize: "13px" }}>
                      <p>End times vary; the event will most likely end sometime around {endTime}. You can check the server status <a rel="noreferrer" target='_blank' href={'https://www.seaofthieves.com/status'}>here</a>.</p>
                    </div>
                  </div>
                )}
                {(duration && !event.deadline && !event.announcement) && (
                  <div className={styles.accordion__content__wrapper}>
                    <div className={styles.accordion__content__label}>Duration: </div>
                    <div className={styles.accordion__content__text}>{duration}</div>
                  </div>
                )}
                {event.description && (
                  <div className={clsx(styles.accordion__content__wrapper, styles.accordion__content__description)}>
                    <div className={styles.accordion__content__label}>About: </div>
                    <div
                      className={styles.accordion__content__text}
                      dangerouslySetInnerHTML={{ __html: event.description }}
                    />
                  </div>
                )}
              </div>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
}

export default EventList;